/* global process */
let base = window._env_.VUE_APP_FIN_CENTER_HOST
export const getNewReceivedPaymentTable = params => {
  return axios.post(`${base}/received-payment/lists`, params)
}
export const getNewReceivedPaymentDetail = params => {
  return axios.get(`${base}/received-payment/${params.id}`, {params})
}
export const exportCollectionRelatedDetail = params => {
  return axios.post(`${base}/received-payment/related/export`, params)
}
export const createReceivedPaymentData = params => {
  return axios.post(`${base}/received-payment/create`, params)
}
export const updateReceivedPaymentData = params => {
  return axios.post(`${base}/received-payment/${params.id}/edit`, params)
}
export const deleteReceivedPaymentData = params => {
  return axios.post(`${base}/deleteReceivedPaymentData/${params.id}`, params)
}
export const forceFinishCollection = params => {
  return axios.post(`${base}/received-payment/${params.id}/force_finish`, params)
}

// 回款数据汇总
export const getReceivedPaymentSummary = params => {
  return axios.post(`${base}/received-payment/summary`, params)
}



// WEBPACK FOOTER //
// ./src/views/received-payment/received-payment.api.js